import { Injectable } from '@angular/core';

export interface CarState {
	id: string;
	background: string;
	foreground: string;
	gpsX: number;
	gpsY: number;
	x: number; // screen-space x position
	y: number; // screen-space y position
	inPit: boolean;
}

@Injectable({
	providedIn: 'root',
})
export class CarManagerService {
	cars: Map<string, CarState> = new Map();

	reset() {
		this.cars = new Map();
	}

	snapAllToGps() {
		this.cars.forEach((car) => {
			car.x = car.gpsX;
			car.y = car.gpsY;
		});
	}

	markInPit(id: string) {
		const car = this.cars.get(id);
		if (car) {
			car.inPit = true;
		}
	}

	removeCar(id: string) {
		this.cars.delete(id);
	}

	updateCarGps(
		id: string,
		x: number,
		y: number,
		background: string,
		foreground: string,
		snapToPosition = false,
	) {
		let car = this.cars.get(id);

		if (!car || snapToPosition) {
			if (car) car.inPit = false;
			if (!car) {
				car = {
					id,
					background,
					foreground,
					gpsX: x,
					gpsY: y,
					x,
					y,
					inPit: false,
				};
				this.cars.set(id, car);
			} else {
				// Car exists but is rejoining — snap directly to position
				car.x = x;
				car.y = y;
				car.gpsX = x;
				car.gpsY = y;
			}
			return;
		}

		car.gpsX = x;
		car.gpsY = y;
		car.background = background;
		car.foreground = foreground;
		car.inPit = false;
	}

	updatePositions(deltaTimeMs: number, averageInterval: number) {
		const avgInterval = averageInterval;
		const SMOOTH_HALF_LIFE = avgInterval * 0.5;
		const alpha = 1 - Math.pow(0.5, deltaTimeMs / SMOOTH_HALF_LIFE);
		this.cars.forEach((car) => {
			car.x += (car.gpsX - car.x) * alpha;
			car.y += (car.gpsY - car.y) * alpha;
		});
	}

	getCars() {
		return Array.from(this.cars.values());
	}
}
